import { MutationCache, QueryClient } from '@tanstack/react-query';
import { toast } from '@/lib/toast';
import { errorMessage } from '@/lib/errors';

/**
 * Every failed mutation tells the person, with the BFF's own words. A mutation that
 * handles its error itself (an `onError` of its own, or `meta: { inline: true }`) is left alone.
 */
export function createQueryClient() {
  return new QueryClient({
    defaultOptions: { queries: { staleTime: 10_000, retry: 1 } },
    mutationCache: new MutationCache({
      onError: (error, _vars, _ctx, mutation) => {
        if (mutation.options.onError || mutation.meta?.inline) return;
        toast(errorMessage(error));
      },
    }),
  });
}
